<footer>
    <section class="footer">
        <div class="left-content">
            <div class="footer-ud-image"></div>
            <p class="version">Version: {{ versionNumber }}</p>
        </div>

        <div class="footer-copyright">
            <p>&copy;{{ year }} Digital Deal Jacket - All Rights Reserved. (US Patent Number 11,930,148)</p>
            <div class="footer-docs">
                <p class="mx-0 cursor" (click)="viewPrivacy()">Privacy Policy</p>
                <p class="mx-0">&nbsp; and &nbsp;</p>
                <p class="mx-0 cursor" (click)="viewTandC()">End User Agreement</p>
            </div>
        </div>

        <div class="right-content">
            <ng-container>
                <div class="footer-ddj-image">
                    <img class="ddj-logo-color" src="../../assets/img/4-powered-by-ddj-non-beta-colored.png" alt="ddj logo" />
                    <img class="ddj-logo-white" src="../../assets/img/6-powered-by-ddj-non-beta.png" alt="ddj logo" />
                </div>
            </ng-container>
        </div>
    </section>
</footer>
